import { render, staticRenderFns } from "./Zpay.vue?vue&type=template&id=4ce6363e&"
import script from "./Zpay.vue?vue&type=script&lang=js&"
export * from "./Zpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports